import { Divider, Flex, FlexItem } from '@patternfly/react-core'
import * as React from 'react'
import { useCallback, useMemo } from 'react'

import { displayLabelIfExists } from '@app/domain/instrument/instrument.helpers'
import type {
  IProgram,
  IProgramInteraction} from '@app/domain/program/program.interface';
import {
  ProgramInteractionTypeId,
  editInteractionInstrumentsModalTittle,
  selectInteractionInstrumentsModalTittle,
} from '@app/domain/program/program.interface'
import { SmallButton } from '@app/utils/styles/small-button'

import { InteractionSection } from './interaction-section'

interface Props {
  onEditInteraction: (
    modalTittle: string,
    programInteractionTypeId: ProgramInteractionTypeId,
    programInteraction?: IProgramInteraction,
  ) => void
  program: IProgram
}

export const InitialInteraction = ({ onEditInteraction, program }: Props) => {
  const handleEditInteraction = useCallback(
    (programInteraction) => {
      return (event) => {
        event.preventDefault()
        onEditInteraction(
          editInteractionInstrumentsModalTittle,
          ProgramInteractionTypeId.InitialInteraction,
          programInteraction,
        )
      }
    },
    [onEditInteraction],
  )

  const handleAddInteraction = useCallback(() => {
    return (event) => {
      event.preventDefault()
      onEditInteraction(
        selectInteractionInstrumentsModalTittle,
        ProgramInteractionTypeId.InitialInteraction,
      )
    }
  }, [onEditInteraction])

  const renderedInteractions = useMemo(() => {
    const numberOfInitialInteractions =
      program?.interactions[ProgramInteractionTypeId.InitialInteraction]
        ?.length ?? 0
    if (numberOfInitialInteractions === 0) {
      return (
        <>
          <FlexItem className="label">Instruments:</FlexItem>
          <SmallButton variant="secondary" onClick={handleAddInteraction()}>
            Edit
          </SmallButton>
        </>
      )
    } else {
      const programInteractions =
        program.interactions[ProgramInteractionTypeId.InitialInteraction]
      return programInteractions.map((programInteraction) => {
        return (
          <>
            <FlexItem className="label">Instruments:</FlexItem>
            <FlexItem>
              <SmallButton
                variant="secondary"
                onClick={handleEditInteraction(programInteraction)}
              >
                Edit
              </SmallButton>
            </FlexItem>
            <FlexItem>
              {programInteraction.instruments
                ?.map(displayLabelIfExists)
                .join(', ')
                .toString()}
            </FlexItem>
          </>
        )
      })
    }
  }, [handleAddInteraction, handleEditInteraction, program])

  return (
    <InteractionSection
      toolTip="The interaction used to collect baseline information on a patient in a program."
      subtitle="Initial Interaction"
    >
      <Divider />
      <Flex>{renderedInteractions}</Flex>
    </InteractionSection>
  )
}
